import React from 'react';
import { Box } from '../material-ui/Box';
import DefaultLogo from '../../icons/image/DefaultLogo';
import { useStyles } from './useStyles';

const Logo = ({ width, height, isCustomCompany }) => {
    const classes = useStyles();
    const company = process.env.COMPANY;

    return isCustomCompany ? (
        <Box className={classes.container}>
            <img src={`/build/static/logo/${company}.svg`} alt={`${company} logo`} className={classes.customLogo} />
        </Box>
    ) : (
        <DefaultLogo width={width} height={height} />
    );
};

export default Logo;
